import React from 'react';

const SvgBt = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="BT_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="BT_svg__b" fill="#fff">
        <use xlinkHref="#BT_svg__a" />
      </mask>
      <use fill="#FFF" xlinkHref="#BT_svg__a" />
      <path fill="#FF5F38" mask="url(#BT_svg__b)" d="M0 0h28v20H0z" />
      <path fill="#FFD951" mask="url(#BT_svg__b)" d="M0 20L28 0H0z" />
    </g>
  </svg>
);

export default SvgBt;
